export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.15 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
